export const getActiveDenominations = <T>(
  denominations: Record<string, T[]>,
  activeCountry: string | null,
  isGameWithRegions: boolean
) => (isGameWithRegions ? denominations[activeCountry || Object.keys(denominations)[0]] : denominations.noRegion)
